import { gql } from "@apollo/client";

interface OauthScopeDescriptionFragment {
  title: string;
  subTitle: string;
  description: string;
  includes: string[];
  kind: string;
}

const OAUTH_SCOPE_DESCRIPTION_FRAGMENT = gql`
  fragment OauthScopeDescriptionFragment on OauthScopeDescription {
    title
    subTitle
    description
    includes
    kind
  }
`;
export type { OauthScopeDescriptionFragment };
export { OAUTH_SCOPE_DESCRIPTION_FRAGMENT };
